/**
 * @generated SignedSource<<150bd81fa0e2a0958714f3a454531fb0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AdminListBrandsRequest = {
  accountId?: string | null;
  includeArchived?: boolean | null;
  pageNumber?: number | null;
  pageSize?: number | null;
  search?: string | null;
};
export type UserFormDialogBrandFlagsQuery$variables = {
  input: AdminListBrandsRequest;
};
export type UserFormDialogBrandFlagsQuery$data = {
  readonly adminListBrands: {
    readonly data: ReadonlyArray<{
      readonly featureFlagIds: ReadonlyArray<string>;
      readonly id: string;
    }>;
  };
};
export type UserFormDialogBrandFlagsQuery = {
  response: UserFormDialogBrandFlagsQuery$data;
  variables: UserFormDialogBrandFlagsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminBrandList",
    "kind": "LinkedField",
    "name": "adminListBrands",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminBrand",
        "kind": "LinkedField",
        "name": "data",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featureFlagIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserFormDialogBrandFlagsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserFormDialogBrandFlagsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d4143dfaa448f7d0f1d3bb61a248ce4b",
    "id": null,
    "metadata": {},
    "name": "UserFormDialogBrandFlagsQuery",
    "operationKind": "query",
    "text": "query UserFormDialogBrandFlagsQuery(\n  $input: AdminListBrandsRequest!\n) {\n  adminListBrands(input: $input) {\n    data {\n      id\n      featureFlagIds\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0ed131cad7186ec76d17016995fdbb61";

export default node;
